import { render, staticRenderFns } from "./UpdateEmail.vue?vue&type=template&id=776f5890&scoped=true"
import script from "./UpdateEmail.vue?vue&type=script&lang=js"
export * from "./UpdateEmail.vue?vue&type=script&lang=js"
import style0 from "./UpdateEmail.vue?vue&type=style&index=0&id=776f5890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776f5890",
  null
  
)

export default component.exports